import moment from "moment";
import jMoment from "moment-jalaali";
import React from "react";
import JalaliUtils from "@date-io/jalaali";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

class PersianDate extends React.Component {
  state = {
    selectedDate: moment()
  };

  render() {
    const { className, label } = this.props;

    return (
      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
        <KeyboardDatePicker
          clearable
          okLabel="تأیید"
          cancelLabel="لغو"
          clearLabel="پاک کردن"
          labelFunc={date => (date ? date.format("jYYYY/jMM/jDD") : "")}
          value={this.state.selectedDate}
          onChange={value => this.setState({ selectedDate: value })}
          inputVariant="outlined"
          label={label}
          className={className}
        />

        {/* <TimePicker
        clearable
        okLabel="تأیید"
        cancelLabel="لغو"
        clearLabel="پاک کردن"
        labelFunc={date => (date ? date.format("hh:mm A") : "")}
        value={selectedDate}
        onChange={handleDateChange}
      />

      <DateTimePicker
        okLabel="تأیید"
        cancelLabel="لغو"
        labelFunc={date => (date ? date.format("jYYYY/jMM/jDD hh:mm A") : "")}
        value={selectedDate}
        onChange={handleDateChange}
      /> */}
      </MuiPickersUtilsProvider>
    );
  }
}

export default PersianDate;
